const AppConfig = {
  global: {
    themeColor: "#755B41",
    navbarHeight: 70,
    navbarCoverContent: false,
    // supportedPayType: ["ecpay", "offline"],
    supportedPayType: ["neweb", "neweb_cvs_cod"],
    supportDeliveryType: ["home_mailing", "cvs"]
  },

  data: {
    localProductSearchFields: ["name", "description"]
  },

  "Components/Footer": {},

  "Components/Navbar": {
    background: "#e6e6e6",
    altBackground: "#e6e6e6",
    textColor: "black",
    textShadow: "2px 2px #ccc",
    breakpoint: 800
  },

  "Components/Lightbox": {
    imageCss: `
      width: 100px;
      height: 100px;
      margin: 10px;

      @media screen and (max-width: 600px) {
        width: 80px;
        height: 80px;
        margin: 5px;
      }
    `,
    thumbnailCss: `
      width: 80px;
      height: 80px;
    `
  },

  "Components/OrderList": {
    css: `
    @media screen and (max-width: 780px) {
      border: 0px;

    }
    @media screen and (max-width: 450px) {
      border: 0px;
    }
    `
  },

  "Components/AddToCartButton": {
    css: `
      max-width: 200px;
      & button {
        border: 1px solid #755B41;
        background-color: white;
        font-size: 16px;
        color: #755B41;
      }
    `
  },

  "Components/BuyNowButton": {
    css: `
      max-width: 200px;
      & button {
        border: 1px solid #755B41;
        background-color: white;
        font-size: 16px;
        color: #755B41;
      }
    `
  },

  "Components/FilterPanel": {
    breakPointTablet: 1024
  },

  "Component/SortingGroup": {
    color: "gray",
    articlesOptions: [
      { label: "發表日期", value: "created" },
      { label: "更新日期(新 → 舊)", value: "-updated" },
      { label: "更新日期(舊 → 新)", value: "+updated" }
    ],
    productsOptions: [
      { label: "新品上市", value: "created" },
      { label: "價格 ⇧", value: "-price" },
      { label: "價格 ⇩", value: "+price" }
    ],
    css: `
      margin-bottom: 50px;
      @media screen and (max-width: 550px) {
        margin-bottom: 10px;
      }
    `
  },

  "Component/SortOption": {
    color: "#755B41",
    css: ``
  },

  "Templates/LandingPage": {
    css: `
    `
  },

  "Templates/OrderDetailPage": {
    css: ``
  },

  "Templates/CartPage": {
    css: ``
  },

  "Templates/ProductListingPage": {
    layoutType: "grid",
    itemLimit: 12,
    breadcrumbs: true,
    itemSearching: false,
    css: `
      flex-direction: row;
      max-width: 1165px;
      margin: 75px auto 0px auto;
      background-color: white;

      & > .products-filter {
        box-shadow: none;
      }

      & > .products-content {
          @media screen and (max-width: 1024px) {
            margin-left: 0px;
          }
      }
    `
  },

  "Templates/StoreDetailPage": {
    css: `
    `
  },

  "Templates/ArticleListingPage": {
    layoutType: "list"
  }
};

module.exports = AppConfig;
